import React, { FC } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { setUiCartItemModal } from 'app/store/reducers/ui.reducer';
import { LastOrderItemCard } from 'entities/Orders/components/LastOrderItemCard';
import { IOrderItemModel } from 'entities/Orders/Orders.models';

export const LastOrderPanel: FC = () => {
  const dispatch = useAppDispatch();

  const { customerModel } = useAppSelector((state) => state.customer);
  const { storeModel } = useAppSelector((state) => state.store);
  const { lastOrderModel } = useAppSelector((state) => state.order);

  const store = customerModel?.store || storeModel || undefined;
  const items = lastOrderModel?.items ?? [];

  const handleLastOrderItemClick = (item: IOrderItemModel) => {
    dispatch(setUiCartItemModal({ isVisible: true, lastOrderItem: item }));
  };

  if (!store || !lastOrderModel) {
    return null;
  }

  return (
    <div className="last-order-panel">
      <div className="last-order-panel-container">
        <div className="mb-5 font-weight-bold color-darkCherry">Your Last Order</div>

        <div className="last-order-panel-items">
          {items.map((item) => (
            <LastOrderItemCard key={item.id} item={item} onClick={handleLastOrderItemClick} />
          ))}
        </div>
      </div>
    </div>
  );
};
